export const getUsername = (state) => {
    return state.user.username;
};